export const useMsgState = () => {
  const message = useState("message", () => "");
  const setMsg = (msg: string) => (message.value = msg);
  return { message, setMsg };
};
